<template>
  <main>
    <GridWrapper>
      <SectionSet isFirst>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <BreadCrumbs
            class="col-span-6 col-start-1 text-lg uppercase leading-[1.4] tracking-[0.08em] text-ng70 laptop:col-span-10 laptop:col-start-2 laptop:text-xl laptop:leading-[2]"
          />
          <h1
            class="col-span-6 col-start-1 text-lg font-medium leading-[1.4] laptop:col-span-7 laptop:col-start-2 laptop:text-[32px] laptop:leading-[1.7]"
          >
            {{ forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.hero_title }}
          </h1>
          <LargeImageContainer :image="'/images/jam-jar.jpg'" :color="'bg-pink'" />
          <div class="col-span-6 col-start-1 mt-[90px] text-center laptop:col-span-8 laptop:col-start-3 laptop:mt-14">
            {{ forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.hero_paragraph }}
            <div class="mt-8 laptop:mt-10">
              <HighlightedLink :to="{ name: 'contact' }"
                ><template #title>{{ $t("contact-us-to-discuss") }}</template></HighlightedLink
              >
              <span>
                {{ forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.hero_paragraph_2 }}
              </span>
            </div>
          </div>
        </div>
      </SectionSet>
      <SectionSet>
        <Stepper
          ><StepperStep
            v-for="step in forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes
              ?.process_steps"
            :step="step?.step"
            :key="JSON.stringify(step)"
            :img="step?.image?.data?.attributes?.url"
            :subtitle="step?.text"
        /></Stepper>
      </SectionSet>
    </GridWrapper>
    <!--    <SectionSet>
      <CustomizationSection class="w-full" />
    </SectionSet>-->
    <GridWrapper>
      <SectionSet isLast>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h4 class="col-span-6 col-start-1 mx-auto laptop:col-span-6 laptop:col-start-4">
            {{ forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_title }}
          </h4>
          <p class="subtitle col-span-6 col-start-1 mx-auto mt-8 laptop:col-span-8 laptop:col-start-3 laptop:mt-10">
            {{ forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_subtitle }}
          </p>
          <div
            class="col-span-6 col-start-1 mt-8 flex flex-col space-y-6 laptop:col-span-10 laptop:col-start-2 laptop:mt-10 laptop:flex-row laptop:space-y-0 laptop:space-x-6"
          >
            <LinkCard
              :bg="'bg-grey'"
              :title="
                forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_our_products
                  ?.title
              "
              :subtitle="
                forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_our_products
                  ?.subtitle
              "
              :img="
                forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_our_products
                  ?.image?.data?.attributes?.url
              "
              :link="localePath({ name: 'products' })"
              :arrow="'#5B7E44'"
            />
            <LinkCard
              :bg="'bg-green'"
              :title="
                forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_brands?.title
              "
              :subtitle="
                forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_brands?.subtitle
              "
              :img="
                forBusinessPrivateLabelPageData?.forBusinessPrivateLabelPage?.data?.attributes?.tiles_brands?.image
                  ?.data?.attributes?.url
              "
              :link="localePath({ name: 'brands' })"
              :arrow="'#A4C91D'"
            />
          </div>
          <NextBtn
            class="col-span-6 mx-auto mt-[23px] laptop:col-span-12 laptop:mt-[129px]"
            :text="$t('Contact us to discuss your PL')"
            :to="localePath({ name: 'contact' })"
          />
        </div>
      </SectionSet>
    </GridWrapper>
  </main>
</template>
<script setup lang="ts">
const pageTitle = ref<string | null>(null);
const { locale, finalizePendingLocaleChange } = useI18n();

const localePath = useLocalePath();

await finalizePendingLocaleChange();

const { data: forBusinessPrivateLabelPageData } = await useAsyncGql({
  operation: "PrivateLabelPage",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

watch(
  forBusinessPrivateLabelPageData,
  (newVal) => {
    if (newVal) {
      if (newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaTitle) {
        pageTitle.value = newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaTitle;
      }
      useHead({
        title: () => pageTitle.value,
      });
      useServerSeoMeta({
        title: () => `${newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaTitle}`,
        ogTitle: () => `${newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaTitle}`,
        description: () => `${newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaDescription}`,
        ogDescription: () => `${newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaDescription}`,
        ogImage: () => `${newVal.forBusinessPrivateLabelPage?.data?.attributes?.seo?.metaImage?.data?.attributes?.url}`,
      });
    }
  },
  { immediate: true },
);
</script>
<style lang="scss" scoped></style>
